import { createApp } from "vue"
import axios from "axios"
import VueAxios from "vue-axios"
import App from "./App.vue"
import { readSignupBootstrap } from "./bootstrap.js"
import { captureUtmParams } from "./utm.js"

// Must run before the app mounts, while window.location.search is still intact.
captureUtmParams()

const root = document.querySelector("#app")

createApp(App, readSignupBootstrap(root))
	.use(VueAxios, axios)
	.mount(root)
